namespace advisorop.components.meetinghub {
    
    class MeetingHubDashboardController {
        $router;
        private meetingHubService: services.MeetingHubService;
        user: domains.identity.IUser;
        isServicer: boolean = false;
        isAdvisor: boolean = false;
        advisorObj: domains.IAdvisor;
        isInvestor: boolean = false;
        isMeetingAvailabilitySet: boolean = true;
        calendarControls: domains.MeetingHubControllers = domains.MeetingHubControllers.CALENDAR;
        meetingCreatorControl: domains.MeetingHubControllers = domains.MeetingHubControllers.MEETING_CREATOR;
        meetingAvailabilityCreatorControl: domains.MeetingHubControllers = domains.MeetingHubControllers.MEETING_AVAILABILITY_CREATOR;
        meetingListControl: domains.MeetingHubControllers = domains.MeetingHubControllers.MEETING_LIST;
        meetingSelectorControl: domains.MeetingHubControllers = domains.MeetingHubControllers.MEETING_SELECTOR;

        public meetings: domains.IMeeting[] = [];
        public outlookEvents: domains.IMeeting[] = [];
        public calendars: domains.IMeetingHubCalendar[] = [];
        meetingDateRange: domains.MeetingDateRange = new domains.MeetingDateRange();

        public showController: { controller: domains.MeetingHubControllers };

        public meeting: domains.IMeeting;
        public meetingDate: Date;

        constructor(private _meetingHubService: services.MeetingHubService, private identityService: services.IdentityService,
            private advisorService: services.AdvisorService, private $timeout: ng.ITimeoutService, private $scope: ng.IScope) {
            _meetingHubService = this.meetingHubService;
        }

        showControl(control: domains.MeetingHubControllers): boolean {
            return (control === (this.showController.controller & control));
        }

        onCreateMeeting(date: Date): void {
            this.meetingDate = date;
            if (this.meeting == undefined) {
                this._meetingHubService.reserveMeeting().then(response => {
                    this.meeting = response.data;
                    this.$timeout(function (meetingHubDashboardController) {
                        meetingHubDashboardController.showController.controller = domains.MeetingHubControllers.MEETING_CREATOR;
                    }, 0, true, this);
                })
            } else {
                this.$timeout(function (meetingHubDashboardController) {
                    meetingHubDashboardController.showController.controller = domains.MeetingHubControllers.MEETING_CREATOR;
                }, 0, true, this);
            }
        }

        onEditMeeting(meeting: domains.IMeeting): void {
            this.meeting = meeting;
            this.$timeout(function (meetingHubDashboardController) {
                meetingHubDashboardController.showController.controller = domains.MeetingHubControllers.MEETING_CREATOR;
            }, 0, true, this);
        }

        onDeleteMeeting(meeting: domains.IMeeting): void {
            this.meeting = meeting;
            this.deleteMeeting();
        }

        onDatesChanged(): void {
            console.log("Dates changed");
            this.getAllMeetings();
            this.getOutlookCalendarEvents();
        }

        onSetMeetingAvailability() {
            this.showController.controller = domains.MeetingHubControllers.MEETING_AVAILABILITY_CREATOR;
        }

        getAllMeetings() {
            this._meetingHubService.getAllMeeting(this.meetingDateRange.fromDate, this.meetingDateRange.toDate).then(result => {
                this.meetings = result.data.concat();
            })
        }

        getOutlookCalendarEvents() {
            this.advisorService.getAdvisorCalendarEvents(this.meetingDateRange.fromDate, this.meetingDateRange.toDate).then(resp => {
                this.outlookEvents = new Array<any>();
                this.outlookEvents = resp.data.concat();
                var localTimeZoneOffset = (new Date()).getTimezoneOffset();
                this.outlookEvents.forEach(e => {
                    if (e.isAllDay) {
                        var start = new Date(e.startDate);
                        var adjustedDateTime = new Date(start.getTime() + localTimeZoneOffset * 60000);
                        e.startDate = adjustedDateTime;
                        var end = new Date(e.endDate);
                        adjustedDateTime = new Date(end.getTime() + localTimeZoneOffset * 60000);
                        e.endDate = adjustedDateTime;
                    }
                })
                console.log(resp);
            }).catch(err => {
                console.log(err);
            })
        }

        getCalendars() {
            this._meetingHubService.getCalendars().then(result => {
                if (result.success) {
                    this.calendars = result.data.concat();
                }
            })
        }

        setCalendarControl(): void {
            this.$timeout(function (meetingHubDashboardController) {
                meetingHubDashboardController.showController.controller = domains.MeetingHubControllers.CALENDAR;
            }, 0, true, this);
        };

        scheduleMeetingLater(): void {
            this._meetingHubService.scheduleMeetingLater(this.meeting).then(result => {
                var newMeet = result.data
                this.meetings.push(newMeet);
                this.meetings = this.meetings.concat();
                this.getOutlookCalendarEvents();
                console.log(result);
            }).finally(() => {
                this.meeting = undefined;
            })
            this.setCalendarControl();
        };

        createMeeting(): void {
            this._meetingHubService.createMeeting(this.meeting).then(result => {
                var newMeet = result.data
                this.meetings.push(newMeet);
                this.meetings = this.meetings.concat();
                this.getOutlookCalendarEvents();
                console.log(result);
            }).finally(() => {
                this.meeting = undefined;
            })
            this.setCalendarControl();
        };

        updateMeeting(): void {
            this._meetingHubService.updateMeeting(this.meeting).then(result => {
                var indexOfOldMeeting = this.meetings.indexOf(this.meeting);
                if (indexOfOldMeeting > -1) {
                    this.meetings.splice(indexOfOldMeeting, 1);
                }
                var newMeet = result.data;
                this.meetings.push(newMeet);
                this.meetings = this.meetings.concat();
                this.getOutlookCalendarEvents();
            }).finally(() => {
                this.meeting = undefined;
            })
            this.setCalendarControl();
        }

        deleteMeeting(): void {
            this._meetingHubService.deleteMeeting(this.meeting.id).then(result => {
                var meetingToRemoveIndex = this.meetings.indexOf(this.meeting);
                if (meetingToRemoveIndex > -1) {
                    this.meetings.splice(meetingToRemoveIndex, 1);
                    this.meeting = undefined;
                }
            }).catch(reason => {
                console.log(`Failed to delete meeting - ${reason}`);
            })
        }

        meetingAvailabilitySet(): void {
            this.isMeetingAvailabilitySet = true;
            this.setCalendarControl(); 
        }

        cancel(): void {
            this.meeting = undefined;
            this.setCalendarControl();
        };

        resetController(): void {
            this.showController = (this.isMeetingAvailabilitySet || this.isServicer || this.isInvestor) ? { controller: domains.MeetingHubControllers.CALENDAR } : { controller: domains.MeetingHubControllers.MEETING_AVAILABILITY_CREATOR };
        }

        $onInit(): void {
            this.resetController();
            this.identityService.getUserPromise().then(response => {
                this.isServicer = this.isAdvisor = this.isInvestor = false;
                this.user = response;
                switch (this.user.systemLoginType) {
                    case domains.SystemLoginType.SERVICER:
                        this.isServicer = true;
                        this.resetController();
                        break;
                    case domains.SystemLoginType.ADVISOR:
                        this.isAdvisor = true;
                        this.advisorService.getAdvisor().then(response => {
                            this.advisorObj = response.data;
                        })
                        this._meetingHubService.getAvailableSchedules().then(resp => {
                            this.isMeetingAvailabilitySet = resp.data.length > 0;
                            this.resetController();
                        })
                        break;
                    case domains.SystemLoginType.INVESTOR:
                        this.isInvestor = true;
                        this.resetController();
                        break;
                }

            });

            this.getAllMeetings();
            this.getOutlookCalendarEvents();
            this.getCalendars();
        }

        $onChanges(evt) {
            console.log(evt);
        }

        $routerOnActivate(next, previous) {
        }
    }

    class MeetingHubDashboard implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.controller = [`meetingHubService`, 'identityService', `advisorService`, '$timeout', MeetingHubDashboardController];
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/meeting-hub-module/views/meeting-hub-dashboard.html";
        }

    }
    angular.module(Constants.APP).component("meetingHubDashboard", new MeetingHubDashboard());
}